import { render } from "./AuthCard.vue?vue&type=template&id=00d8cee4&scoped=true"
import script from "./AuthCard.vue?vue&type=script&lang=js"
export * from "./AuthCard.vue?vue&type=script&lang=js"

import "./AuthCard.vue?vue&type=style&index=0&id=00d8cee4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d8cee4"]])

export default __exports__